const validate = (value, args) => {
  let regex = /^\d+$/
  if (!regex.test(value)) {
    return false
  }

  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'Your index should contain only numbers, please check the encoded value'
  }
}
